
<ng-container *ngIf="isVisible && informacion">

  <div class="">
    <div class="absolute-design-logo">
      <img class="logo-vertical-primario" width="100%" [src]="parametros.LOGO_VERTICAL_PRIMARIO" alt="logo">
    </div>
    
    <ngx-loading
      class="loading loading-absolute"
      [show]="isVisible"
      [config]="{
        animationType: ngxLoadingAnimationTypes.wanderingCubes,
        primaryColour: primaryColour,
        secondaryColour: secondaryColour,
        backdropBorderRadius: '0px'
      }">
    </ngx-loading>
    <div 
      class="absolute-design"
    >
      <p>{{informacion.titulo}}</p>
      <p class="font-title-light" style="color: grey;">{{informacion.descripcion}}</p>
    </div>
  </div>
  
</ng-container>

